export default options => a => {
  if (typeof a === 'function') return a;

  if (options.selection) {
    return a.isRowAction;
  }

  return (!a.isFreeAction && !a.isSelectedAction) || a.isRowAction;
};
